import React, { useState } from 'react';
import { useUISettings } from '../../context/UISettingsContext';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../common/Button';

export function RecoverAccountModal() {
  const { isRecoverModalOpen, setIsRecoverModalOpen, recoverWithCode, recoverWithPassword, showNotification } = useUISettings();
  const { dispatch, ACTIONS } = useAuth();
  const [mode, setMode] = useState('select');
  const [uuid, setUuid] = useState('');
  const [recoveryCode, setRecoveryCode] = useState('');
  const [password, setPassword] = useState('');

  if (!isRecoverModalOpen) return null;

  const handleRecoverWithCode = async () => {
    if (uuid && recoveryCode) {
      const newToken = await recoverWithCode(uuid, recoveryCode);
      if (newToken) {
        dispatch({ type: ACTIONS.SET_TOKEN_INPUT, payload: newToken });
        dispatch({ type: ACTIONS.SET_AUTH_MODE, payload: 'login' });
        setIsRecoverModalOpen(false);
      }
    }
  };

  const handleRecoverWithPassword = async () => {
    if (uuid && password) {
      const newToken = await recoverWithPassword(uuid, password);
      if (newToken) {
        dispatch({ type: ACTIONS.SET_TOKEN_INPUT, payload: newToken });
        dispatch({ type: ACTIONS.SET_AUTH_MODE, payload: 'login' });
        setIsRecoverModalOpen(false);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <h3 className="text-xl font-bold mb-4 text-gray-800">Recover Account</h3>
        
        {mode === 'select' && (
          <>
            <p className="text-sm text-gray-600 mb-6">
              Choose a recovery method:
            </p>
            <div className="space-y-4">
              <button
                onClick={() => setMode('code')}
                className="w-full p-4 border-2 border-blue-200 rounded-lg hover:bg-blue-50 transition text-left"
              >
                <div className="font-semibold">Use Recovery Code</div>
                <div className="text-xs text-gray-500">Get a new session token using a recovery code</div>
              </button>
              <button
                onClick={() => setMode('password')}
                className="w-full p-4 border-2 border-green-200 rounded-lg hover:bg-green-50 transition text-left"
              >
                <div className="font-semibold">Use UUID + Password</div>
                <div className="text-xs text-gray-500">Get a new session token using your UUID and password</div>
              </button>
            </div>
            <button 
              onClick={() => setIsRecoverModalOpen(false)} 
              className="mt-6 text-gray-500 hover:text-gray-700 text-sm w-full"
            >
              Cancel
            </button>
          </>
        )}

        {mode === 'code' && (
          <>
            <p className="text-sm text-gray-600 mb-4">
              Enter your UUID and one of your recovery codes:
            </p>
            <input
              type="text"
              placeholder="Your UUID"
              value={uuid}
              onChange={(e) => setUuid(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="text"
              placeholder="Recovery Code (XXXX-XXXX-XXXX)"
              value={recoveryCode}
              onChange={(e) => setRecoveryCode(e.target.value.toUpperCase())}
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex justify-end space-x-4">
              <Button onClick={() => setMode('select')} variant="secondary">
                Back
              </Button>
              <Button 
                onClick={handleRecoverWithCode} 
                disabled={!uuid || !recoveryCode}
                variant="primary"
              >
                Recover
              </Button>
            </div>
          </>
        )}

        {mode === 'password' && (
          <>
            <p className="text-sm text-gray-600 mb-4">
              Enter your UUID and password to get a new session token:
            </p>
            <input
              type="text"
              placeholder="Your UUID"
              value={uuid}
              onChange={(e) => setUuid(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex justify-end space-x-4">
              <Button onClick={() => setMode('select')} variant="secondary">
                Back
              </Button>
              <Button 
                onClick={handleRecoverWithPassword} 
                disabled={!uuid || !password}
                variant="primary"
              >
                Get New Token
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}